module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-120x120-c6d2ce8c79c6c4d165da7a8436946e0e.png";